import { Component, OnInit, Input, OnChanges, ViewChild, EventEmitter, Output,HostListener } from '@angular/core';
import { ToastService, IMyOptions, MDBDatePickerComponent} from 'ng-uikit-pro-standard';
import { KeycloakService } from 'keycloak-angular';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment';
import { SharedService } from 'src/app/shared/shared.service';
import { AppConstants } from 'src/app/config.service';
import { ExceptionHandlingService } from 'src/app/shared/exception-handling.service';
import { DocumentHandlingService } from 'src/app/shared/document-handling.service';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { CommonDeleteModalComponent } from 'src/app/common/modals/common-delete-modal/common-delete';
import { Subject } from 'rxjs';
import { Subscription } from 'rxjs';
import { UploadService } from 'src/app/header/header-component/upload/upload.service';
import { UtilitiesService } from 'src/app/shared/utilities.service';
import { AuthService } from 'src/app/auth.service';
import {GlobalConstants} from 'src/app/global-constants';

@Component({
  selector: 'app-edit-component-modal',
  templateUrl: './edit-component.html',
  styles: [`
  
  .upload-button {
    display: inline-block;
    border: none;
    outline: none;
    cursor: pointer;
    color: #ffffff;
  }
  .upload-button:hover {
    color:#014c8c
  }
  .upload-button input {
    display: none;
  }

.comment {
    padding: 8px 0;
    width: 100%;
    border-top: 1px dotted #dedede;
}
.mr20{
    width: 20px;
    margin-right: 5px;
}
.ml-0{
    margin-left:0px !important
}

.file_link {
  color:#729bbc;
}
.file_link:hover {
  color:#a4cbeb;
  text-decoration:underline;
}

.floating-upload-button input {
  display: none;
} 

.upload-button {
  display: inline-block;
  outline: none;
  cursor: pointer;
  color:#fff;
  background-color: #729bbc;
  padding:3px 8px;
  border-radius:3px;
  margin-top:5px;
}

.upload-button:hover {
  background-color: #95c5e0
}

.upload-button input {
  display: none;
}


div.file_zone {
  border: 1px solid #ccc;
  background-color: #fff;
  margin: 10px 10px;
  padding: 10px;
  box-shadow: 0 3px 4px rgba(0, 0, 0,0.2);
  transition: box-shadow 0.4s ease-in-out;
}

div.file_zone:hover {
  box-shadow: 0 9px 12px rgba(0,0,0,0.1);
}


div.dropzone {
  background-color: #fafafa;
  border: 1px dashed #ccc;
  color: #999;
  height: 90px;
  padding: 5px;
}

div.dropzone div {
  width: 100%;
  height: 100%;
  padding: 10px;
  text-align: center;
}


.upload-button:hover {
  color:#014c8c
}
.upload-button input {
  display: none;
}
div.dropzone:hover {
  background-color:#eff7ff
}

.card-header {
  background-color:#f7f7f7;
  border-color:#e9e9e9;
  color:#555
  }

.piecesTable,
.attachmentsTable,
.datesTable {
  width:100%
}
.piecesTable td,
.attachmentsTable td {
  padding:8px !important;
  border-bottom:1px dotted #ededed;
  line-height:16px;
}
.piecesTable td:first-child,
.attachmentsTable td:first-child {
  width:40px;
  font-weight:400;
  color:#999;
}
.piecesTable td:last-child,
.attachmentsTable td:last-child {
  width:50px;
}
table th, table td {
  padding:8px !important;
}
.comment-badge {
  position: absolute;
  z-index: 2;
  width: 13px;
  height: 13px;
  border-radius: 7px;
  border: 5px solid red;
  background-color: #fff;
  top: 8px;
  right: auto;
  left: 32px;
}
  div.dropzone {
  position:relative;
    background-color:#fafafa;
    border:1px dashed #ccc;
    color:#999;
    width:100%;
    height:100px;
    padding:20px;
  }`]
})

export class EditComponentTab implements OnInit, OnChanges {

  @Input() selectedCertificate: any = {};
  subs: Subscription;

  constructor(
    private service: SharedService,
    private appConstants: AppConstants,
    private translate: TranslateService,
    private keycloakService: KeycloakService,
    private errorService: ExceptionHandlingService,
    private toastr: ToastService,
    private UploadService: UploadService,
    private KeycloakService: KeycloakService,
    private UtilitiesService: UtilitiesService,
    private docService: DocumentHandlingService,
    private authService : AuthService
  ) {
    this.customSearchWord.pipe(
      debounceTime(600),
      distinctUntilChanged())
      .subscribe(value => {
        this.resetTestingLocationPaginfo();
        this.testingLocations = [];
        this.name = value;
        this.getTestingLocations();
      });

    this.subs = this.UploadService.loadDocsList.subscribe(docs => {
      this.getMarkTestedDocuments();
    })
  }

  ngOnDestroy()
  { if( this.subs)
      this.subs.unsubscribe();
    if(this.customSearchWord)
      this.customSearchWord.unsubscribe();
  }

  customSearchWord = new Subject<string>();
  searchEvent(e) {
    if(e && e.term)
    this.customSearchWord.next(e.term)
  }

  currencyConfig = {
    align: "right",
    allowNegative: false,
    allowZero: true,
    decimal: ".",
    precision: 2,
    prefix: "$ ",
    suffix: "",
    thousands: ",",
    nullable: true
  }

  userInfo: any = {};
  canShowEditComponentFee : boolean = false;
  canEditTestingLocation : boolean = false;
  canDeleteReceiveLogEntry : boolean = false;
  async ngOnInit() {
    if (await this.keycloakService.isLoggedIn()) {
      const user = this.appConstants.userDetails;
      this.canShowEditComponentFee = await this.authService.checkRoleExist('editComponentFee');
      this.canEditTestingLocation = await this.authService.checkRoleExist('editTestingLocation');
      this.canDeleteReceiveLogEntry = await this.authService.checkRoleExist('canDeleteReceiveLogEntry');
      this.userInfo = user
    }
  }

  pageInfo = {
    id: 'edit-modal-pagination',
    itemsPerPage: 1,
    currentPage: 1,
    totalItems: 0,
    disablePagination: false
  };

  todaysDate = new Date();
  
   datePickerOptions: IMyOptions = {
    dateFormat: 'mmm-dd-yyyy',
    closeAfterSelect: true,
    editableDateField:false
  };

  datePickerOptions2: IMyOptions = {
    disableSince: {year:this.todaysDate.getFullYear(),month:this.todaysDate.getMonth()+1,day:this.todaysDate.getDate()+1},
    dateFormat: 'mmm-dd-yyyy',
    closeAfterSelect: true,
    editableDateField:false
  };
  
  @ViewChild('datePicker1', { static: true }) datePicker1: MDBDatePickerComponent;
  @ViewChild('datePicker2', { static: true }) datePicker2: MDBDatePickerComponent;
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode == 27 && this.datePicker1.isOpen) {
      this.datePicker1.closeBtnClicked();
    }
    else if (event.keyCode == 27 && this.datePicker2.isOpen) {
      this.datePicker2.closeBtnClicked();
    }
    else if (event.keyCode == 27 && this.editComponentSelectionModal.isShown){
      this.editComponentSelectionModal.hide()
    }
  }

  action: any = {}
  ngOnChanges() {
    if (this.selectedCertificate && this.selectedCertificate.id) {
      this.pageInfo.currentPage = 1;
      this.pageInfo.disablePagination = true;
      this.action = {};
      this.selectedTab = '1';
      this.uploadedFiles = [];
      this.cancelReasons = [];
      this.testingLocations = [];
      this.documents = [];
      if(this.selectedCertificate.isFromSearchSelections)
      this.getSelectionCertificateComponents(this.selectedCertificate)
      else
      this.getComponentDetails(this.selectedCertificate.component)
      this.editComponentSelectionModal.show();
    }
  }

  editModalSelectedComponentDetails : any = {}
  getComponentDetails(comp) {
    let url = this.appConstants.endPoints.certificatesEndPoint + comp.certificateId + '/component-selections/' + comp.componentSelectionId + '/components/' + comp.id;
    this.commentsLoader = true;
    this.service.get(url, {})
      .pipe(finalize(() => {
        this.commentsLoader = false;
      }))
      .subscribe(data => {
        this.selectedComponent = data ? data : {};
        this.selectedComponent.amountFee = this.selectedComponent.amountFee ? this.selectedComponent.amountFee : {value :""};
        if(data && data.componentTestLocation)
        this.selectedComponent.componentTestLocation = {id : data.componentTestLocation.id , name: data.componentTestLocation.name}
          if (data && data.quantity * 1 != data.totalComponentsReceived) {
            this.selectedComponent.componentsReceived = (data.quantity * 1);
        }
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })
  }

  setTabDetails(tab) {
    switch (tab) {
      case '1' : this.getNotes(); break;
      case '2' : this.getRecievedComponents(); break;
      case '3' : this.getMarkTestedTab(); break;
      case '4' : this.getCancelTab(); break;
      case '5' : this.getDuplicatesTab(); break;
      default: this.getNotes();
    }
  }

  getDuplicatesTab() {
    this.selectedTab = '5';
    this.getDuplicates()
  }

  duplicateComponents: any = [
    {
      aboutPath: null,
      amountFee: { value: 430, dateCurrencySaved: "2020-08-04T06:39:16Z", formattedCurrency: "$430.00" },
      certificateNumber: '100017962CRT-001x',
      componentCode: "23",
      componentTestLocation: { id: "d9976f1c-2c0c-372d-9cee-0c3647cbd194", name: "USA, Plymouth" },
      componentType: "SUBASSEMBLY",
      createdByInfo: { name: "robyn.hills@sematree.com", link: null },
      currencyISOCode: "USD",
      dateCanceled: null,
      dateCreated: { date: "2020-03-03T12:48:21Z", dateMilliseconds: 1583239701845, dateFormat: "MMM-dd-yyyy" },
      id: "f2d6feef-4fc7-45df-a3b8-4695d8bdf845",
      manufacturer: "GSI",
      model: "106E208",
      name: "Tilt Switch (Not shown)",
      photoNumber: "8",
      quantity: null,
      quantityText: "1",
      referenceId: "00000000-0000-0000-0000-000000000000",
      state: null,
      status: null
    },
    {
      aboutPath: null,
      amountFee: null,
      certificateNumber: '100017962CRT-002',
      componentCode: "13",
      componentTestLocation: { id: "eb0912d4-2054-4251-a06e-00f73bd796c8" },
      componentType: "INSULATED COIL",
      createdByInfo: { name: "robyn.hills@sematree.com", link: null },
      currencyISOCode: null,
      dateCanceled: null,
      dateCreated: { date: "2020-03-18T20:38:31Z", dateMilliseconds: 1584563911814, dateFormat: "MMM-dd-yyyy" },
      id: "56512265-bcc8-42ad-8792-30ce15b8bcb2",
      manufacturer: "Tyco Electronics /(American Zetler)",
      model: "F4/VF4 /(AZ974-1c-24D)",
      name: null,
      photoNumber: "3",
      quantity: null,
      quantityText: "1",
      referenceId: "00000000-0000-0000-0000-000000000000",
      state: null,
      status: null
    }]


  getDuplicates() {}


  getCancelTab(){
    this.selectedTab = '4';
    this.action = {};
    let d = new Date()
    this.action.dateCanceled = moment(d).format('MMM-DD-YYYY');
  }
  
  cancelReasons:any=[];
  cancelReasonsLoading:boolean = false;
  getCancelReasons(){
    this.cancelReasons = [];
    this.cancelReasonsLoading = true;
    const url = this.appConstants.endPoints.certificatesEndPoint + 'options/component-cancel-reasons';
    this.service.post(url, {}, {
      "pageNumber": 1,
      "pageSize": 50,
      "isPaging": true,
      "status": true
    })
      .pipe(finalize(() => {
        this.cancelReasonsLoading = false;
      }))
      .subscribe(data => {
        this.cancelReasons = data && data.searchResults ? data.searchResults : [];
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })
  }
  cancelComponentsLoading: boolean = false;
  confirmCancelComponents() {
      let url = this.appConstants.endPoints.certificatesEndPoint + this.selectedCertificate.id + '/component-selections/' + this.selectedComponent.componentSelection.id + '/components/' + this.selectedComponent.id + '/cancel';
      
      let modelSchema = {
          "dateCanceled": moment(this.action.dateCanceled).utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
          "comments": this.action.comments ? this.action.comments : '',
          "applyToMasterData": this.action.applyToMasterData ? true:false,
          "cancelReason": {id:this.action.cancelReason.id}
      }

      this.cancelComponentsLoading = true;
      this.service.put(url, {}, modelSchema).pipe(finalize(() => {
          this.cancelComponentsLoading = false;
          }))
          .subscribe(data => {
              this.toastr.success(this.translate.instant('administration_componentsCanceledSuccessfully_label'), this.translate.instant('administration_confirmation_label'));
          },
          error => {
          this.errorService.errorHandling(error).then(res => {
              this.error = res;
          });
      })
  }


  @ViewChild('editComponentSelectionModal', { static: true }) editComponentSelectionModal: any;
  editModalLoader: boolean = false
  error: any = {}
  getSelectionCertificateComponents(cert) {
    const url = this.appConstants.endPoints.certificatesEndPoint + cert.id + '/component-selections/' + cert.componentSelectionId + '/query-components';
    this.editModalLoader = true;
    this.service.post(url, {}, {
      "isPaging": false
    })
      .pipe(finalize(() => {
        this.editModalLoader = false;
      }))
      .subscribe(comps => {
        cert.components = comps ? comps.searchResults : [];
        cert.components = cert.components.map(res => {
          cert.status = cert.status ? cert.status.name : null;
          cert.amountFee = cert.amountFee ? cert.amountFee :  {value :""};
          if (res.quantity * 1 != res.totalComponentsReceived) {
            res['isSelected'] = true;
            res['componentsReceived'] = (res.quantity * 1);
          }
          return res
        })
        this.selectedComponent = cert.components[0];
        this.setTabDetails(this.selectedTab)
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })
  }


  paginationChange(event) {
    if (this.selectedCertificate.components && this.selectedCertificate.components[event - 1])
      this.selectedComponent = this.selectedCertificate.components[event - 1];
    this.setTabDetails(this.selectedTab);
    this.action = {};
    this.uploadedFiles = [];
    this.pageInfo.currentPage = event;
  }

  resetTestingLocationPaginfo() {
    this.testingLocationPagingInfo.pageNumber = 1;
    this.name = ""
  }

  fetchMoreFavourities() {
    if (this.testingLocationPagingInfo.totalRows > this.testingLocations.length) {
      this.testingLocationPagingInfo.pageNumber += 1;
      this.getTestingLocations();
    }
  }


  testingLocations: any = [];
  testingLocationsLoading: boolean = false;
  testingLocationPagingInfo: any = {
    pageNumber: 1,
    pageSize: 20,
    totalRows: 0
  }

  name: any = {}
  getTestingLocations() {
    
    const url = this.appConstants.endPoints.certificatesEndPoint + 'options/component-test-locations';
    this.testingLocationsLoading = true;

    let modifiedObj = { isPaging: true, pageNumber: this.testingLocationPagingInfo.pageNumber, pageSize: this.testingLocationPagingInfo.pageSize }

    if (this.name && this.name.length)
      modifiedObj['name'] = this.name

    this.service.post(url, {}, modifiedObj)
      .pipe(finalize(() => {
        this.testingLocationsLoading = false;
      }))
      .subscribe(data => {
        if (data) {
          const pageInfo = data && data.pagingInfo ? data.pagingInfo.totalRows : 0;
          this.testingLocationPagingInfo.totalRows = pageInfo;
          let locations = data && data.searchResults ? data.searchResults : [];
          locations = locations.map(res => {
            return { name: res.name, id: res.id }
          })
          this.testingLocations = [...this.testingLocations, ...locations];
        }
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })
  }


  statuses: any = [];
  statusesLoading: boolean = false;
  getStatuses() {
    this.statuses = [];
    const url = this.appConstants.endPoints.certificatesEndPoint + this.selectedCertificate.id + '/component-selections/' + this.selectedCertificate.componentSelectionId + '/components/' + this.selectedComponent.id + '/status-options';
    this.statusesLoading = true;
    this.service.get(url, {})
      .pipe(finalize(() => {
        this.statusesLoading = false;
      }))
      .subscribe(data => {
        if (data) {
          this.statuses = data;
          this.statuses = this.statuses.map(res => { return { id: res.id, name: res.name } })
        }
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })
  }


  @Output() emitSuccess = new EventEmitter<any>();
  selectedTab: string = '1';

  updateComponentDetails() {

    let modelSchema = {
      "name": this.selectedComponent.name,
      "model": this.selectedComponent.model,
      "quantityText": this.selectedComponent.quantityText,
      "quantity": this.selectedComponent.quantity,
      "manufacturer": this.selectedComponent.manufacturer,
      "componentType": this.selectedComponent.componentType,
      "componentCode": this.selectedComponent.componentCode,
      "amountFee": this.selectedComponent.amountFee.value,
      "componentTestLocation": { id: this.selectedComponent.componentTestLocation.id },
      "referenceId": this.selectedCertificate.referenceId,
      "stateId" : this.selectedComponent && this.selectedComponent.state && this.selectedComponent.state.id ? this.selectedComponent.state.id : null
    }

    this.editModalLoader = true;
    const url = this.appConstants.endPoints.certificatesEndPoint + this.selectedCertificate.id + '/component-selections/' + this.selectedCertificate.componentSelectionId + '/components/' + this.selectedComponent.id;
    this.service.put(url, {}, modelSchema).pipe(finalize(() => {
      this.editModalLoader = false;
    }))
      .subscribe(data => {
        this.toastr.success(this.translate.instant('administration_editComponentsUpdated_label'));
      },
        error => {
          this.errorService.errorHandling(error).then(res => {
            this.error = res;
          });
        })
  }

  selectedComponent: any = {}
  editComment: any = {}
  getNotes() {
    this.action = { comment: "" }
    this.selectedTab = '1';
    this.editComment = {};
    this.comments = [];
    this.getComponentComments(this.selectedComponent)
  }

  comments: any = [];
  commentsLoader: boolean = false
  getComponentComments(comp) {
    this.comments = [];
    let url = this.appConstants.endPoints.certificatesEndPoint + this.selectedCertificate.id + '/component-selections/' + this.selectedCertificate.componentSelectionId + '/components/' + comp.id + '/query-comments';
    this.commentsLoader = true;
    this.service.post(url, {}, {})
      .pipe(finalize(() => {
        this.commentsLoader = false;
      }))
      .subscribe(data => {
        if (data) {
          this.comments = data && data.searchResults ? data.searchResults : [];
        }
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })

  }

  @ViewChild('modifyCommentModal', { static: true }) modifyCommentModal: any;

  openModifyCommentModal(comment) {
    this.editComment = Object.assign({}, comment);
    this.modifyCommentModal.show();
  }

  addNewComment(comment) {
    this.error = {}
    let modifiedObj = { comments: comment }
    this.commentsLoader = true
    this.service
      .post(this.appConstants.endPoints.certificatesEndPoint + this.selectedCertificate.id + '/component-selections/' + this.selectedCertificate.componentSelectionId + '/components/' + this.selectedComponent.id + '/comments', {}, modifiedObj)
      .pipe(finalize(() => {
        this.commentsLoader = false
      })).subscribe(data => {
        this.action.comment = ''
        this.toastr.success(this.translate.instant('administration_SuccessfullyUpdated_label'));
        this.modifyCommentModal.hide();
        this.getComponentComments(this.selectedComponent)
      }), res => {
        
      }
  }

  updateCommentLoader: boolean = false
  submitComment(comment) {
    this.error = {}
    let modifiedObj = { comments: comment.comments }
    this.updateCommentLoader = true

    this.service
      .put(this.appConstants.endPoints.certificatesEndPoint + this.selectedCertificate.id + '/component-selections/' + this.selectedCertificate.componentSelectionId + '/components/' + this.selectedComponent.id + '/comments/' + comment.id, {}, modifiedObj)
      .pipe(finalize(() => {
        this.updateCommentLoader = false
      })).subscribe(data => {
        this.editComment = '';
        this.getComponentComments(this.selectedComponent);
        this.toastr.success(this.translate.instant('administration_SuccessfullyUpdated_label'));
        this.modifyCommentModal.hide();
      }), res => {

      }

  }

  @ViewChild(CommonDeleteModalComponent, { static: true })
  commonDeleteModal: CommonDeleteModalComponent;
  selectedComment: any = {}
  deleteFlag: any = ""
  confirmDeleteModal(item) {
    this.deleteFlag = 'comment'
    this.selectedComment = item;
    this.commonDeleteModal.open({ name: item.comments }, this.translate.instant('administration_deleteComment_label'), this.translate.instant('administration_deleteCommentConfirmation_label'))
  }
  confirmDelete(e) {
    if (e) {
      if (this.deleteFlag == 'comment') {
        this.commonDeleteModal.isLoading = true;
        this.service.delete(this.appConstants.endPoints.certificatesEndPoint + this.selectedCertificate.id + '/component-selections/' + this.selectedCertificate.componentSelectionId + '/components/' + this.selectedComponent.id + '/comments/' + this.selectedComment.id, {})
          .pipe(finalize(() => {
            this.commonDeleteModal.isLoading = false;
          }))
          .subscribe(response => {
            this.commonDeleteModal.close();
            this.error = {};
            this.toastr.success(this.translate.instant('administration_commentDeleted_label'));
            this.getComponentComments(this.selectedComponent);
          }, res => {
            this.errorService.errorHandling(res).then(res => {
              this.error = res;
            });
          });
      }
      if (this.deleteFlag == 'document') {
        this.commonDeleteModal.isLoading = true;
        this.service
          .delete(this.appConstants.endPoints.sprigEndPoint + 'documents/' + GlobalConstants.applicationID + '/documents/' + this.selectedDocument.id, {})
          .pipe(finalize(() => {
            this.commonDeleteModal.isLoading = false;
          })).subscribe(data => {
            this.commonDeleteModal.close();
            this.toastr.success(this.translate.instant('administration_removedDocument_label'));
            this.getMarkTestedDocuments();
          },
            error => {
              this.errorService.errorHandling(error).then(res => {
                this.error = res;
              });
            })
      }
      if (this.deleteFlag == 'log') {
        this.commonDeleteModal.isLoading = true;
        this.service
          .delete(this.appConstants.endPoints.certificatesEndPoint + this.selectedCertificate.id + '/component-selections/' + this.selectedCertificate.componentSelectionId + '/components/' + this.selectedComponent.id + '/receive-logs/' + this.selectedLog.id, {})
          .pipe(finalize(() => {
            this.commonDeleteModal.isLoading = false;
          })).subscribe(data => {
            this.commonDeleteModal.close();
            this.receivedLogs = this.receivedLogs.filter(item => item.id !== this.selectedLog.id);
            this.toastr.success(this.translate.instant('administration_recievedLogSuccess_label'));
            this.updateStatus();
          },
            error => {
              this.errorService.errorHandling(error).then(res => {
                this.error = res;
              });
            })
      }


    }
  }



  receivedLogs: any = []
  getRecievedComponents() {
    this.selectedTab = '2';
    this.receivedLogs = [];
    this.error = {};
    this.getRecievedLogs();
    let d = new Date();
    this.action = {}
    this.action.dateReceived = moment(d).format('MMM-DD-YYYY');
  }

  receiveLoader: boolean = false
  getRecievedLogs() {
    this.receivedLogs = [];
    this.receiveLoader = true
    let paginfo = { isPaging: false }
    let url = this.appConstants.endPoints.certificatesEndPoint + this.selectedCertificate.id + '/component-selections/' + this.selectedCertificate.componentSelectionId + '/components/' + this.selectedComponent.id + '/query-receive-logs';
    this.commentsLoader = true;
    this.service.post(url, {}, paginfo)
      .pipe(finalize(() => {
        this.receiveLoader = false;
      }))
      .subscribe(data => {
          this.receivedLogs = data && data.searchResults ? data.searchResults : [];
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })
  }

  uploadedFiles: any = [];
  documents: any = []
  getMarkTestedTab() {
    this.selectedTab = '3';
    this.uploadedFiles = [];
    this.documents = [];
    this.getMarkTestedDocuments();
    this.action = {};
    this.getMarkTestedDetails()
  }

getMarkTestedDetails(){
  let url = this.appConstants.endPoints.certificatesEndPoint + this.selectedCertificate.id + '/component-selections/' + this.selectedCertificate.componentSelectionId + '/components/' + this.selectedComponent.id + '/test-complete-meta-data'
  this.editModalLoader = true
  this.service.get(url, {})
      .pipe(finalize(() => {
        this.editModalLoader = false;
      }))
      .subscribe(data => {
        if (data) {
            this.action.testStatus = data.testStatus ? data.testStatus : 0;
            this.action.dateTestCompleted = data.dateTestCompleted ? moment(data.dateTestCompleted.dateMilliseconds).format('MMM-DD-YYYY') : '';
        }
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })
}



  documentPagingInfo = {
    pageSize: 100,
    pageNumber: 1,
    totalRows: 0
  }

  markTestedLoader: boolean = false;
  getMarkTestedDocuments() {
    this.markTestedLoader = true
    this.service
      .get(this.appConstants.endPoints.sprigEndPoint + 'documents/' + GlobalConstants.scheduleApplicationID + '/documents', {
        userName: this.userInfo.email,
        aboutPath: this.selectedComponent.aboutPath,
        pageSize: this.documentPagingInfo.pageSize,
        pageNumber: this.documentPagingInfo.pageNumber,
        applicationId: GlobalConstants.scheduleApplicationID
      })
      .pipe(finalize(() => {
        this.markTestedLoader = false;
      })).subscribe(data => {
        if (data != null) {
          if (data && data.pagingInfo)
            this.documentPagingInfo.totalRows = data.pagingInfo.totalRows
          this.documents = data.searchResults ? data.searchResults : [];
          this.documents.forEach(doc => {
            doc.disabled = doc.fileSize ? false : true
            doc.isFromBackend = true;
          });
        }
      },
        error => {
          this.errorService.errorHandling(error).then(res => {
            this.error = res;
          });
        })

  }


  @ViewChild('dropDocumentsModal', { static: true }) AddDocumentModalComponent: any;

  openDropDocumentsModal() {
    this.uploadedFiles = [];
    this.AddDocumentModalComponent.show();
  }

  statusUpdated(e) { }


  uploadFile(event, ev?) {
    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      element['id'] = Date.now() + Math.random()
      this.uploadedFiles.push(element)
    }
    if (ev && ev.target)
      ev.target.value = null
  }

  isLoading: boolean = false;
  selectedDocument: any = {};
  deleteDocument(obj) {
    this.deleteFlag = 'document'
    this.selectedDocument = obj;
    this.commonDeleteModal.open({ name: this.selectedDocument.name }, this.translate.instant('administration_deleteDocuments_label'), this.translate.instant('administration_deleteDocuments_alert_label'));
  }

  removeFromDocuments(doc) {
    let index = -1;
    for (let i = 0; i < this.uploadedFiles.length; i++) {
      if (this.uploadedFiles[i].id == doc.id) {
        index = i;
        this.uploadedFiles.splice(index, 1);
      }
    }
  }

  markTestCompleteLoading: boolean = false;
  confirmMarkTestComplete() {
    this.editModalLoader = true;
    let url = this.appConstants.endPoints.certificatesEndPoint + this.selectedCertificate.id + '/component-selections/' + this.selectedCertificate.componentSelectionId + '/components/' + this.selectedComponent.id + '/test-complete-meta-data';

    const completedDate = moment(this.action.dateTestCompleted, 'MMM-DD-YYYY').format('MM/DD/YYYY HH:mm')
    let modelSchema = {
      "dateTestCompleted": moment(new Date(completedDate)).utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
      "testStatus": this.action.testStatus
    }

    this.service.put(url, {}, modelSchema).pipe(finalize(() => {
      this.editModalLoader = false;
    }))
      .subscribe(data => {
        this.getMarkTestedTab();
        this.updateStatus();
        this.toastr.success(this.translate.instant('administration_componentsMarkedTestCompleteSuccessfully_label'), this.translate.instant('administration_confirmation_label'));
      },
        error => {
          this.errorService.errorHandling(error).then(res => {
            this.error = res;
          });
        })

  }

  updateStatus(){
    let url = this.appConstants.endPoints.certificatesEndPoint + this.selectedCertificate.id + '/component-selections/' + this.selectedCertificate.componentSelectionId + '/components/' + this.selectedComponent.id + '/status'
    this.editModalLoader = true
    this.service.get(url, {})
        .pipe(finalize(() => {
          this.editModalLoader = false;
        }))
        .subscribe(data => {
            this.selectedComponent.state = data ? {id:data.id,name:data.name} : {};  
        }, error => {
          this.errorService.errorHandling(error).then(res => {
            this.error = res;
          });
        })
  }

  confirmMarkRecievedComponent() {

    this.editModalLoader = true;
    let url = this.appConstants.endPoints.certificatesEndPoint + this.selectedCertificate.id + '/component-selections/' + this.selectedCertificate.componentSelectionId + '/components/' + this.selectedComponent.id + '/receive';

    let modelSchema = {
      "dateReceived": moment(this.action.dateReceived).utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
      "comments": this.action.comment ? this.action.comment : '',
      "componentsReceived": this.selectedComponent.componentsReceived
    }

    this.service.put(url, {}, modelSchema).pipe(finalize(() => {
      this.editModalLoader = false;
    }))
      .subscribe(data => {
        this.getRecievedComponents();
        this.updateStatus();
        this.toastr.success(this.translate.instant('administration_markAsRecieved_label'), this.translate.instant('administration_confirmation_label'));
      },
        error => {
          this.errorService.errorHandling(error).then(res => {
            this.error = res;
          });
        })

  }

  iconFileDetect(fileName) {
    if (fileName) {
      const fileExt = fileName.split('.').pop();
      const icons = {
        "pdf": { icon: "fa-file-pdf" },
        "ppt": { icon: "fa-file-powerpoint" },
        "pptx": { icon: "fa-file-powerpoint" },
        "xls": { icon: "fa-file-excel" },
        "xlsx": { icon: "fa-file-excel" },
        "doc": { icon: "fa-file-word" },
        "docx": { icon: "fa-file-word" },
        "jpg": { icon: "fa-file-image" },
        "png": { icon: "fa-file-image" }
      };
      if (icons[fileExt] != undefined)
        return icons[fileExt].icon
      else
        return "fa-file"
    }
  }

  docDownload(doc) {
    this.docService.goDownload(doc)
  }

  docs: any = [];
  selectedDevice: any
  async startUpload() {
    const getLocalSprig = localStorage.getItem('selectedDevice')
      const selectedDevice = getLocalSprig ? JSON.parse(getLocalSprig) : null;
       
      if (selectedDevice && selectedDevice.basePathUrl && selectedDevice.installationId) {
    if (await this.KeycloakService.isLoggedIn()) {
      const user = this.appConstants.userDetails
      const getSelectedSprig = JSON.parse(localStorage.getItem('selectedDevice'));
      if (getSelectedSprig)
        this.selectedDevice = getSelectedSprig;

      const userName = user.username
      this.AddDocumentModalComponent.hide();
      this.docs = [];
      const docs = [];
      const getDocs = Object.assign([], this.uploadedFiles);
      for (let k = 0; k < getDocs.length; k++) {
        const tagLoop = getDocs[k];
        const obj: any = {};
        obj.file = tagLoop;
        obj.fileName = tagLoop.name;
        obj.referenceId = this.UtilitiesService.UUID().toLowerCase();
        obj.fileSizeInBytes = tagLoop.size;
        docs.push(Object.assign({}, obj));
        this.docs.push(Object.assign({}, obj));
      }
      const modify = Object.assign([], docs);
      if (modify.length)
        modify.forEach(element => {
          delete element.file;
        });
      const obj = { userName: this.userInfo.email, aboutPath: this.selectedComponent.aboutPath, installationId: this.selectedDevice.installationId, documents: modify };
      const url = this.appConstants.endPoints.sprigEndPoint + 'documents/' + GlobalConstants.scheduleApplicationID + '/documents/multiple';
      this.service.post(url, {}, obj, true).subscribe(response => {
        // this.toastr.success(this.translate.instant("Activity Created"));              
        let uploadInfo = [];
        const docResult = response.body;
        for (let i = 0; i < docResult.length; i++) {
          for (let l = 0; l < this.docs.length; l++) {
            if (docResult[i].referenceId == this.docs[l].referenceId) {
              const url = this.selectedDevice.basePathUrl + '/documents/upload/' + docResult[i].id + '?uk=1&installationId=' + this.selectedDevice.installationId + '&fileSize=' + this.docs[l].file.size + '&userName=' + userName + '&fileName=' + encodeURIComponent(this.docs[l].file.name);
              uploadInfo.push({
                id: docResult[i].id,
                url: url,
                param: null,
                method: 'PUT',
                fieldName: 'fileUpload',
                body: this.docs[l].file
              })
            }
          }
        }
        this.UploadService.receiveFiles.next({ upload: uploadInfo });
      }, err => {
        
      });
    }
  }
  else
  this.authService.checksprigAvailable.next({ sprigNotAvailable: true, modalTitle: this.translate.instant('administration_unableToUploadDocuments_label') })
  }

  selectedLog : any = {}
  deleteRecievedComponent(log)
  {
    this.selectedLog = log;
    this.deleteFlag ='log'
    this.commonDeleteModal.open({ name: this.selectedLog.name }, this.translate.instant('administration_deleteLog_label'), this.translate.instant('administration_deleteLogwarning_label'));
  }

}